export default __webpack_public_path__ + "static/media/logo.3a551d14.svg";